import axios from 'axios'

const App_url = process.env.REACT_APP_NODE_BASE_URL;

const ApiServices = axios.create({
    baseURL : App_url,
    headers : {
      'Content-Type': 'application/json',
    },
    withCredentials: true
})


ApiServices.interceptors.request.use((config) => {
  return config;
});


ApiServices.interceptors.response.use(
  (response) => response, // success → return response
  async (error) => {

    if (error?.response) {
      const { status, message } = error?.response;

      // Handle Unauthorized or Technical error
      if ((status === 401) || (status === 500 && message === "Technical Error")) {
        console.warn('Session expired or technical error — logging out...');
        localStorage.clear();
        window.location.href = '/login';
      }
    } else {
      console.error('Network error:', error?.message);
    }

    return Promise.reject(error);
  }
);

  export {ApiServices}